// 手機版選單 會員連結
import { useSelector } from 'react-redux';
import { urlState } from '@/slices/urlSlice';
import { userState } from '@/slices/userSlice';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';

const MenuUserLink = () => {
    const { user } = useSelector(userState);
    const { memberUrl, forumUrl } = useSelector(urlState);
    const { t } = useTranslation();

    // 連結
    const pages = [
        {
            title: 'profile',
            link: '/profile',
            member: true,
        },
        {
            title: 'likes',
            link: '/collection',
            member: true,
        },
        { title: 'secure', link: '/account-security', member: true },
        { title: 'follow', link: `/user/${user?.uid}/following` },
        { title: 'fans', link: `/user/${user?.uid}/followers` },
        {
            title: 'prefs',
            link: '/profile?preference=true',
            member: true,
        },
    ];

    return (
        <ul
            className="hidden ulg:block space-y-[10px] pt-[22px] border-t-1 border-dashed border-purple1 text-btn1 text-black6 [&_span]:text-bd3n [&_span]:text-black3
         ulg:border-opacity-[.4] [&>a]:flex [&>a]:items-center [&>a]:px-[12px] [&>a]:py-[10px] [&>a]:trans [&>a:hover]:bg-black1 [&>a]:rounded-[6px]"
        >
            {pages.map((page) => {
                // 標題、連結
                const title = page.title;
                const link = page.member ? memberUrl + page.link : forumUrl + page.link;

                return (
                    <a
                        key={'mb-menu' + title}
                        href={link}
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <p className="w-[22px] aspect-[1] flex-shrink-0">
                            <Image
                                width={24}
                                height={24}
                                src={`/images/icon/icon_${title}.svg`}
                                alt="icon"
                            />
                        </p>
                        <p className="ml-[10px] mr-[4px]">{t(title.toUpperCase())}</p>
                        <span>{title.toUpperCase()}</span>
                    </a>
                );
            })}
        </ul>
    );
};

export default MenuUserLink;
